import styles from './ProductList.module.scss';
import { useState, useEffect } from 'react';

function ProductList({ header, label, breadcrumb, children, search, onSearch, initialSearchValue = '' }) {
  const [searchValue, setSearchValue] = useState(initialSearchValue);

  // Update search value when initialSearchValue prop changes
  useEffect(() => {
    setSearchValue(initialSearchValue);
  }, [initialSearchValue]);

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchValue);
    }
  };

  return (
    <div className={styles.productList}>
      {header && (
        <h2 className={styles.header}>{header}</h2>
      )}

      {label && (
        <div className={styles.label}>{label}</div>
      )}

      <div className={styles.breadcrumb}>
        {breadcrumb}
      </div>

      {search && (
        <div className={styles.searchBox}>
          <form className={styles.searchForm} onSubmit={handleSubmit}>
            <div className={styles.searchFormContainer}>
              <input
                type="text"
                placeholder="Search"
                value={searchValue}
                onChange={handleInputChange}
                className={styles.searchInput}
              />
              <button type="submit" className={styles.searchButton}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={styles.searchIcon}>
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </div>
          </form>
        </div>
      )}

      {
        children && (
          <div className={styles.body}>
            {children}
          </div>
        )
      }
    </div>
  );
}

export default ProductList;
